module.exports = __webpack_public_path__ + "static/img/minicons3.c8e83ff5.png";